import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import ReactPlayer from 'react-player';
import Image from 'Components/Image';
import assetUrl from 'Utils/assetUrl';
import LottieLoader from 'Components/LottieLoader';

const MediaPlayerModal = props => {
  const { modalClose, modalData: { tjkMediaPlayerModal } } = props;
  
  return (
    <Modal
      className="horse-racing-mediplayer-modal"
      onClose={ modalClose }
      title={ '' }
      position={ {
        web: 'center',
        mobile: 'center'
      } }
    >
      <div className='horse-racing-mediplayer-modal__title'>
        { tjkMediaPlayerModal.hippodrome }
        <br />
        { tjkMediaPlayerModal.runInfo }
      </div>

      { tjkMediaPlayerModal.type === 'video' && <div className='horse-racing-media-player-wrapper'>
        <ReactPlayer
          controls
          className='horse-racing-media-player'
          playing={ true }
          playIcon
          url={ tjkMediaPlayerModal.url }
          width='100%'
          height='100%'
        />
      </div> }
      
      { tjkMediaPlayerModal.type === 'photo' && <Image
        src={ tjkMediaPlayerModal.url }
        loader={
          <LottieLoader type="loading" loop={ true } autoplay width="30px" />
        }
        unloader={
          <img src={ assetUrl('bilyoner.png') } alt="AltılıGanyan" />
        }
      /> }
    </Modal>
  );
};

MediaPlayerModal.propTypes = {
  modalClose: PropTypes.func,
  props: PropTypes.object,
  tjkMediaPlayerModal: PropTypes.object,
  modalData: PropTypes.object
};

export default MediaPlayerModal;
